import React, { useState } from "react";
import Swal from "sweetalert2";
import { marcarPorRevisar } from "../../utils/Datos";

export const MarcarPorRevisar = ({ id_qualifications }) => {
  const [cargando, setCargando] = useState(false);
  const handlePorRevisar = () => {
    setCargando(true);
    marcarPorRevisar(id_qualifications).then((respuesta) => {
      if (respuesta.status === true) {
        Swal.fire({
          title: "Listo",
          text: "Calificación enviada a revisión",
          icon: "success",
          confirmButtonText: "Ok",
        }).then((okay) => {
          if (okay) {
            window.location.href = "/calificacionesPendientes";
          }
        });
      } else {
        Swal.fire({
          title: "Error",
          text:
            respuesta.errores ??
            "Ocurrió un error, por favor vuelva a intentarlo",
          icon: "error",
          confirmButtonText: "Ok",
        }).then((okay) => {
          if (okay) {
            window.location.href = "/calificacionesPendientes";
          }
        });
      }
      setCargando(false);
    });
  };

  return (
    <button className="btn btn-primary" onClick={handlePorRevisar}>
      {cargando ? " Enviando datos..." : " Por revisar"}
    </button>
  );
};
